import { render, staticRenderFns } from "./AboutMenu.vue?vue&type=template&id=0437ba6e&scoped=true&"
import script from "./AboutMenu.vue?vue&type=script&lang=js&"
export * from "./AboutMenu.vue?vue&type=script&lang=js&"
import style0 from "./AboutMenu.vue?vue&type=style&index=0&id=0437ba6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0437ba6e",
  null
  
)

export default component.exports